import { render, staticRenderFns } from "./SendDocumentRemindTable.vue?vue&type=template&id=50fb1d6c&scoped=true&lang=pug"
import script from "./SendDocumentRemindTable.vue?vue&type=script&lang=ts"
export * from "./SendDocumentRemindTable.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentRemindTable.vue?vue&type=style&index=0&id=50fb1d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb1d6c",
  null
  
)

export default component.exports